import React, { useState } from "react";
import "./menu.css";
import historico from "../../../assets/mobile/icones/historico.png";
import sobre from "../../../assets/mobile/icones/sobre.png";
import sair from "../../../assets/mobile/icones/sair.png";

function Menu({ trocarPagina, paginaAtual }) {
    const [mostrarMaisOpcoes, setMostrarMaisOpcoes] = useState(false);

    const maisOpcoes = () => {
        setMostrarMaisOpcoes(!mostrarMaisOpcoes);
    };

    // Verifica se a página atual está entre as opções adicionais
    const isOpcaoAdicionalAtiva = ["Histórico", "Sobre", "Sair"].includes(paginaAtual);

    return (
        <nav className="menu-mobile">
            <div id="barraDeOpções-mobile">
                <div id="barraDeOpções-Botoes-mobile">
                    {!mostrarMaisOpcoes && (
                        <button
                            id="btn-more-mobile"
                            className={`btn-mobile${mostrarMaisOpcoes || isOpcaoAdicionalAtiva ? "-active" : ""}`}
                            onClick={maisOpcoes}
                        >
                            <p id="text-mais-mobile-inverso">☰</p>
                        </button>
                    )}
                    
                </div>
            </div>
            <div className={`maisOpcoes${mostrarMaisOpcoes ? "-ativo" : ""}`}>
                {mostrarMaisOpcoes && (
                    <>
                        <button
                            id="btn-more-mobile-inverso"
                            className={`btn-mais-mobile${mostrarMaisOpcoes ? "-active" : ""}`}
                            onClick={maisOpcoes}
                        >
                            <p>☰</p>
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Histórico" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Histórico"); maisOpcoes(); }}
                        >
                            <img src={historico} style={{ width: 25 }} alt="Histórico" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sobre" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sobre"); maisOpcoes(); }}
                        >
                            <img src={sobre} style={{ width: 25 }} alt="Sobre" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sair" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sair"); maisOpcoes(); }}
                        >
                            <img src={sair} style={{ width: 25 }} alt="Sair" />
                        </button>
                    </>
                )}
            </div>
        </nav>
    );
}

export default Menu;